import React from 'react';
import { clsx } from 'clsx';

interface PayInvoiceBtnProps {
  invoiceId?: string;
  invoiceNumber?: string;
  dateDue?: string;
  amount?: number;
  payButtonLabel?: string;
  invoicePaymentUrl?: string;
  additionalCtaClass?: string;
}

export default function PayInvoiceBtn({
  invoiceId,
  invoiceNumber,
  dateDue,
  amount,
  invoicePaymentUrl,
  payButtonLabel,
  additionalCtaClass = '',
}: Readonly<PayInvoiceBtnProps>) {
  const formattedAmount = amount ? amount.toFixed(2) : '';
  const payUrl =
    `${invoicePaymentUrl}?invoiceId=${encodeURIComponent(invoiceId ?? '')}` +
    `&invoiceNumber=${encodeURIComponent(invoiceNumber ?? '')}` +
    `&dueDate=${encodeURIComponent(dateDue ?? '')}` +
    `&amount=${encodeURIComponent(formattedAmount ?? '')}`;
  const showPayButton = amount > 0 && invoicePaymentUrl.length > 0;

  if (!showPayButton) return null;

  return (
    <a href={payUrl} className={clsx('cta', 'cta--primary', 'cta--small', additionalCtaClass)}>
      {payButtonLabel}
    </a>
  );
}
